import { useState } from "react";
import { useLanguage } from "./LanguageContext";

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        borderBottom: "1px solid rgba(30, 64, 175, 0.1)",
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 0",
          background: "none",
          border: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        <span
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "1.05rem",
            color: "var(--blue-800)",
            fontWeight: 600,
            paddingRight: "16px",
          }}
        >
          {question}
        </span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--blue-400)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            flexShrink: 0,
            transition: "transform 0.3s",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      <div
        style={{
          maxHeight: open ? "500px" : "0",
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
      >
        <div
          style={{
            paddingBottom: "20px",
            color: "#64748b",
            lineHeight: 1.7,
            fontSize: "0.95rem",
          }}
        >
          {answer}
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const { t } = useLanguage();

  const hotelLink = (
    <a href="#hotels" style={{ color: "var(--blue-600)", textDecoration: "underline" }}>
      {t.hotelsHeading}
    </a>
  );

  const faqA3WithLink = (
    <span>
      {t.faqA3Before}{hotelLink}{t.faqA3After}
    </span>
  );

  const faqs = [
    { q: t.faqQ1, a: t.faqA1 },
    { q: t.faqQ2, a: t.faqA2 },
    { q: t.faqQ3, a: faqA3WithLink },
    { q: t.faqQ4, a: t.faqA4 },
    { q: t.faqQ5, a: t.faqA5 },
    { q: t.faqQ6, a: t.faqA6 },
    { q: t.faqQ7, a: t.faqA7 },
  ];

  return (
    <section
      id="faq"
      style={{
        padding: "80px 20px",
        background: "white",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "48px" }}>
        <p
          style={{
            letterSpacing: "3px",
            textTransform: "uppercase",
            fontSize: "0.85rem",
            color: "var(--blue-400)",
            marginBottom: "8px",
          }}
        >
          {t.faqSubtitle}
        </p>
        <h2 className="section-heading">{t.faqHeading}</h2>
        <div className="divider-ornament">
          <span style={{ color: "var(--gold)" }}></span>
        </div>
      </div>

      <div
        style={{
          maxWidth: "650px",
          margin: "0 auto",
          background: "var(--blue-50)",
          borderRadius: "16px",
          padding: "8px 32px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        }}
      >
        {faqs.map((faq, i) => (
          <FAQItem key={i} question={faq.q} answer={faq.a} />
        ))}
      </div>

      {/* Registry Section */}
      <div
        style={{
          maxWidth: "650px",
          margin: "48px auto 0",
          textAlign: "center",
          background: "linear-gradient(135deg, var(--blue-50) 0%, white 100%)",
          borderRadius: "16px",
          padding: "40px 32px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          border: "1px solid var(--blue-100)",
        }}
      >
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          style={{ margin: "0 auto 16px" }}
        >
          <path
            d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"
            stroke="var(--gold)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h3
          style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: "1.5rem",
            color: "var(--blue-800)",
            marginBottom: "12px",
          }}
        >
          {t.registryHeading}
        </h3>
        <p
          style={{
            color: "#64748b",
            lineHeight: 1.6,
            marginBottom: "24px",
            maxWidth: "450px",
            margin: "0 auto 24px",
          }}
        >
          {t.registryDescription}
        </p>
        <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
          <a
            href="https://www.amazon.com/wedding/guest-view/MKD14Z1DK6AG"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-wedding"
            style={{
              display: "inline-block",
              padding: "14px 40px",
              textDecoration: "none",
              fontSize: "1rem",
            }}
          >
            {t.registryButtonAmazon}
          </a>
          <a
            href="https://www.macys.com/registry/Diana-Aquino-Elijah-Quinones/1406263"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-wedding"
            style={{
              display: "inline-block",
              padding: "14px 40px",
              textDecoration: "none",
              fontSize: "1rem",
            }}
          >
            {t.registryButtonMacys}
          </a>
        </div>
      </div>
    </section>
  );
}
